import React from 'react';
import ReactDOM from 'react-dom/client';
//import { BrowserRouter } from 'react-router-dom';
import App from './components/app/App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // <Provider store={store}>
  <App />,
  // </Provider>,
);
